/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getClientHints } from "../../utils/PRIVATE_clientHints";

const clientPlatform = getClientHints().platform;
export const supportsMobileScreenReader = clientPlatform === 'android' || clientPlatform === 'ios';
